import type { MapInstance } from './store'

export interface ExplorerUrlState {
  collection?: string
  variable?: string
  qa?: string
  cmap?: string
  vmin?: number
  vmax?: number
  autoscale?: boolean
  opacity?: number
  t?: number | string
  bbox?: [number, number, number, number]
  center?: [number, number]
  zoom?: number
}

/**
 * Build a URLSearchParams string from a serialisable viewer state.
 * All params are optional — omit falsy/undefined values so shared links
 * stay short.
 */
export function buildExplorerSearch(s: ExplorerUrlState): string {
  const q = new URLSearchParams()
  const set = (k: string, v: string | number | boolean | undefined | null) => {
    if (v === undefined || v === null || v === '') return
    q.set(k, String(v))
  }
  set('collection', s.collection)
  set('variable', s.variable)
  set('qa', s.qa)
  set('cmap', s.cmap)
  set('vmin', s.vmin)
  set('vmax', s.vmax)
  set('autoscale', s.autoscale ? '1' : undefined)
  set('opacity', s.opacity)
  set('t', s.t)
  if (s.bbox) set('bbox', s.bbox.join(','))
  if (s.center) set('center', s.center.map((n) => n.toFixed(4)).join(','))
  set('zoom', s.zoom !== undefined ? Number(s.zoom).toFixed(2) : undefined)
  return q.toString()
}

/** Read + snapshot the current maplibre viewport into { bbox, center, zoom }. */
export function readViewport(map: MapInstance | null): Pick<ExplorerUrlState, 'center' | 'zoom'> {
  if (!map) return {}
  try {
    const b = map.getBounds() as any
    const center = b && typeof b.getWest === 'function'
      ? ([(b.getWest() + b.getEast()) / 2, (b.getSouth?.() + b.getNorth?.()) / 2] as [number, number])
      : undefined
    return { center, zoom: map.getZoom() }
  } catch {
    return {}
  }
}
